import api from './api'

export const committeeService = {
  // Get all committee members
  async getCommitteeMembers() {
    const response = await api.get('/committee/')
    return response.data
  },

  // Get a specific committee member
  async getCommitteeMember(id) {
    const response = await api.get(`/committee/${id}`)
    return response.data
  },

  // Create a new committee member (admin)
  async createCommitteeMember(data) {
    const response = await api.post('/committee/', data)
    return response.data
  },

  // Update a committee member (admin)
  async updateCommitteeMember(id, data) {
    const response = await api.put(`/committee/${id}`, data)
    return response.data
  },

  // Delete a committee member (admin)
  async deleteCommitteeMember(id) {
    const response = await api.delete(`/committee/${id}`)
    return response.data
  }
}